// fallback product images utility
import AirConditionerIcon from '../../assets/fallback-product-images/air-conditioner.svg';
import ErvIcon from '../../assets/fallback-product-images/erv.svg';
import GarbageDisposalIcon from '../../assets/fallback-product-images/garbage-disposal.svg';
import HeatPumpIcon from '../../assets/fallback-product-images/heat-pump.svg';
import HumidifierIcon from '../../assets/fallback-product-images/humidifier.svg';
import DishwasherIcon from '../../assets/fallback-product-images/icon-dishwasher.svg';
import DryerIcon from '../../assets/fallback-product-images/icon-dryer.svg';
import FireplaceIcon from '../../assets/fallback-product-images/icon-fireplace.svg';
import FurnaceIcon from '../../assets/fallback-product-images/icon-furnace.svg';
import GarageOpenerIcon from '../../assets/fallback-product-images/icon-garage-opener.svg';
import HoodIcon from '../../assets/fallback-product-images/icon-hood.svg';
import OvenIcon from '../../assets/fallback-product-images/icon-oven.svg';
import RangeIcon from '../../assets/fallback-product-images/icon-range.svg';
import RefrigeratorIcon from '../../assets/fallback-product-images/icon-refrigerator.svg';
import WasherIcon from '../../assets/fallback-product-images/icon-washer.svg';
import WaterSoftenerIcon from '../../assets/fallback-product-images/icon-water-softner.svg';
import ImageIcon from '../../assets/fallback-product-images/image-icon.svg';
import MicrowaveIcon from '../../assets/fallback-product-images/microwave.svg';
import SumpPumpIcon from '../../assets/fallback-product-images/sump-pump.svg';
import TanklessWaterHeaterIcon from '../../assets/fallback-product-images/tankless-water-heater.svg';
import ThermostatIcon from '../../assets/fallback-product-images/thermostat.svg';
import TrashCompactorIcon from '../../assets/fallback-product-images/trash-compactor.svg';
import WaterHeaterIcon from '../../assets/fallback-product-images/water-heater.svg';

export const fallbackProductImages = {
  air_conditioner: AirConditionerIcon,
  dishwasher: DishwasherIcon,
  dryer: DryerIcon,
  erv: ErvIcon,
  fireplace: FireplaceIcon,
  furnace: FurnaceIcon,
  garage_opener: GarageOpenerIcon,
  garbage_disposal: GarbageDisposalIcon,
  heat_pump: HeatPumpIcon,
  hood: HoodIcon,
  humidifier: HumidifierIcon,
  microwave: MicrowaveIcon,
  oven: OvenIcon,
  range: RangeIcon,
  refrigerator: RefrigeratorIcon,
  sump_pump: SumpPumpIcon,
  tankless_water_heater: TanklessWaterHeaterIcon,
  thermostat: ThermostatIcon,
  trash_compactor: TrashCompactorIcon,
  washer: WasherIcon,
  water_heater: WaterHeaterIcon,
  water_softener: WaterSoftenerIcon
};

/**
 * returns the appropriate fallback image source for a product type
 * @param type - product type string
 * @returns image source URL or default ImageIcon
 */
export const getFallbackProductImage = (type: string): string => {
  return fallbackProductImages[type as keyof typeof fallbackProductImages] || ImageIcon;
};
